import React from "react";

const Header = () => {
  return (
    <header>
      <div className="container">
        <h2>Feedback UI</h2>
      </div>
    </header>
  );
};

export default Header;
